import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string,
    mark: PropTypes.string,
  }).isRequired,
};

const defaultProps = {};

const EMPTY_CHAR = '\uFEFF';

const Leaf = ({ data }) => {
  const text = data.text || EMPTY_CHAR;

  if (data.mark) {
    return <span data-mark={data.mark}>{text}</span>;
  }
  return <span>{text}</span>;
};

Leaf.propTypes = propTypes;
Leaf.defaultProps = defaultProps;

export default Leaf;
